import React, { useState } from 'react';
import { Button } from 'reactstrap';
import DialogBox from './DialogBox';
import {Spinner} from 'reactstrap'
import { useTheme } from '../hooks/useTheme';

export default function ActionButton({ id, color, title, icon, label, busyLabel, onClick, onError, confirmTitle, confirmMessage, confirmButtonLabel = "Confirm", confirmButtonColor = "danger", confirmDialogSize, outline = true, disabled = false }) {
    const theme = useTheme();

    const [isBusy, setIsBusy] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const handleConfirmedClick = async () => {
        if (!onClick || isBusy) {
            return;
        }

        setIsBusy(true);
        try {
            await Promise.resolve(onClick?.());
        } catch (error) {
            if (onError) {
                onError(error);
            } else {
                console.error(`ActionButton ${id} onClick handler threw an error:`, error);
            }
        } finally {
            setIsBusy(false);
        }
    };

    const handleClick = () => {
        if (confirmMessage) {
            setIsConfirmOpen(true);
        } else {
            handleConfirmedClick();
        }
    };

    return (
        <>
            <Button
                id={id}
                color={color}
                outline={outline}
                title={title}
                disabled={isBusy || disabled}
                onClick={handleClick}
            >
                {!isBusy && <i className={`bi ${icon}`}></i>}                
                {isBusy && <Spinner color={color} size="sm" />}
                {!isBusy && label && <span className="ms-2">{label}</span>}
                {isBusy && label && <span className="ms-2">{busyLabel ?? "Busy"}</span>}
            </Button>
            {confirmMessage && (
                <DialogBox
                    isOpen={isConfirmOpen}
                    title={confirmTitle}
                    message={confirmMessage}
                    size={confirmDialogSize}
                    toggle={() => setIsConfirmOpen(false)}
                    buttons={[                            
                        { label: "Cancel", outline, color: theme === "dark-mode" ? "dark" : "light", onClick: () => setIsConfirmOpen(false) },
                        { label: confirmButtonLabel, color: confirmButtonColor, onClick: () => { setIsConfirmOpen(false); handleConfirmedClick(); } }
                    ]}
                />
            )}
        </>
    );
}